import { gql } from '@apollo/client';

export const updatePersonInfo = gql`
  mutation updatePersonPersonalInfo($input: ModifyPersonInput!) {
    salesforce {
      modifyPerson(input: $input)
    }
  }
`;

export const updatePersonAdditionalInfo = gql`
  mutation modifyPersonDetails($input: ModifyPersonDetailsInput!) {
    salesforce {
      modifyPersonDetails(input: $input)
    }
  }
`;

export const createPersonAddress = gql`
  mutation createPersonAddress($input: CreatePersonAddressInput!) {
    salesforce {
      createPersonAddress(input: $input)
    }
  }
`;

export const updatePersonAddress = gql`
  mutation updatePersonAddress($input: ModifyPersonAddressInput!) {
    salesforce {
      modifyPersonAddress(input: $input)
    }
  }
`;

export const createBusinessPartner = gql`
  mutation createBusinessPartner(
    $createBusinessPartnerInput: CreateBusinessPartnerInput!
  ) {
    salesforce {
      createBusinessPartner(
        createBusinessPartnerInput: $createBusinessPartnerInput
      )
    }
  }
`;

export const createBusinessPartnerVignetteRange = gql`
  mutation createPartnerVignetteRange(
    $createBusinessPartnerVignetteInput: CreateBusinessPartnerVignetteInput!
  ) {
    salesforce {
      createBusinessPartnerVignette(
        createBusinessPartnerVignetteInput: $createBusinessPartnerVignetteInput
      )
    }
  }
`;

export const updateBusinessPartnerVignetteRange = gql`
  mutation updatePartnerVignetteRange(
    $modifyBusinessPartnerVignetteInput: ModifyBusinessPartnerVignetteInput!
  ) {
    salesforce {
      modifyBusinessPartnerVignette(
        modifyBusinessPartnerVignetteInput: $modifyBusinessPartnerVignetteInput
      )
    }
  }
`;

export const updateBusinessPartner = gql`
  mutation updateBusinessPartner(
    $modifyBusinessPartnerInput: ModifyBusinessPartnerInput!
  ) {
    salesforce {
      modifyBusinessPartner(
        modifyBusinessPartnerInput: $modifyBusinessPartnerInput
      )
    }
  }
`;

export const createUser = gql`
  mutation createBusinessUser($businessUserInputs: CreateUserInput!) {
    salesforce {
      createUser(input: $businessUserInputs)
    }
  }
`;

export const updateUser = gql`
  mutation updateBusinessUser($userInput: ModifyUserInput!) {
    core {
      modifyUser(userInput: $userInput)
    }
  }
`;

export const createProvider = gql`
  mutation createProvider($createProviderInput: CreateProviderInput!) {
    salesforce {
      createProvider(createProviderInput: $createProviderInput)
    }
  }
`;

export const createAccountingTransfer = gql`
  mutation createAccoutingTransfer($createTransferInput: CreateTransferInput!) {
    accounting {
      createTransfer(createTransferInput: $createTransferInput)
    }
  }
`;

export const createProposal = gql`
  mutation createProposal($input: CreateProposalInput!) {
    production {
      createProposal(input: $input)
    }
  }
`;

export const closeProposal = gql`
  mutation closeProposal($entityId: String!, $closingReason: String!) {
    production {
      closeProposal(id: $entityId, reason: $closingReason)
    }
  }
`;

export const modifyCancellationAmendment = gql`
  mutation modifyCancellationAmendment($input: ModifyAmendmentInput!) {
    production {
      modifyCancellationAmendment(input: $input)
    }
  }
`;

export const addClaim = gql`
  mutation addClaim($createClaimInput: CreateClaimInput!) {
    claimManagement {
      createClaim(createClaimInput: $createClaimInput)
    }
  }
`;

export const closeClaim = gql`
  mutation closeClaim($CloseClaimInput: CloseClaimInput!) {
    claimManagement {
      closeClaim(closeClaimInput: $CloseClaimInput)
    }
  }
`;

export const updateTreatyReinsurers = gql`
  mutation updateTreatyReinsurers(
    $treatyId: String!
    $reinsurers: [ReinsurersInput!]!
  ) {
    reinsurance {
      updateTreatyReinsurers(treatyId: $treatyId, reinsurers: $reinsurers)
    }
  }
`;

export const reactivateTreaty = gql`
  mutation ReactivateTreaty($treatyId: String!, $expiryDate: DateTime!) {
    reinsurance {
      reactivateTreaty(treatyId: $treatyId, expiryDate: $expiryDate)
    }
  }
`;

export const createBusinessPartnerMutation = gql`
  mutation createBusinessPartner(
    $createBusinessPartnerInput: CreateBusinessPartnerInput!
  ) {
    salesforce {
      createBusinessPartner(
        createBusinessPartnerInput: $createBusinessPartnerInput
      )
    }
  }
`;

export const modifyBusinessPartner = gql`
  mutation modifyBusinessPartner(
    $modifyBusinessPartnerInput: ModifyBusinessPartnerInput!
  ) {
    salesforce {
      modifyBusinessPartner(
        modifyBusinessPartnerInput: $modifyBusinessPartnerInput
      )
    }
  }
`;

export const modifyAddress = gql`
  mutation modifyAddress($input: ModifyAddressInput!) {
    salesforce {
      modifyAddress(input: $input)
    }
  }
`;

export const modifyTaxation = gql`
  mutation modifyTaxation($taxationInput: ModifyTaxationInput!) {
    core {
      modifyTaxation(taxationInput: $taxationInput)
    }
  }
`;

export const createTaxationPlanSpecific = gql`
  mutation createTaxationPlanSpecific(
    $planSpecificTaxationInput: NewPlanSpecificTaxationInput!
  ) {
    core {
      createTaxationPlanSpecific(
        planSpecificTaxationInput: $planSpecificTaxationInput
      )
    }
  }
`;

export const modifyPlanSpecificTaxation = gql`
  mutation modifyPlanSpecificTaxation(
    $planSpecificTaxationInput: ModifyPlanSpecificTaxationInput!
  ) {
    core {
      modifyPlanSpecificTaxation(
        planSpecificTaxationInput: $planSpecificTaxationInput
      )
    }
  }
`;

export const activateBusinessPartnerLines = gql`
  mutation activateBusinessPartnerLines(
    $businessPartnerId: String!
    $businesspartnerLines: [String!]!
  ) {
    salesforce {
      activateBusinessPartnerLines(
        businessPartnerId: $businessPartnerId
        businesspartnerLines: $businesspartnerLines
      )
    }
  }
`;

export const deactivateBusinessPartnerLines = gql`
  mutation deactivateBusinessPartnerLines(
    $businessPartnerId: String!
    $businesspartnerLines: [String!]!
  ) {
    salesforce {
      deactivateBusinessPartnerLines(
        businessPartnerId: $businessPartnerId
        businesspartnerLines: $businesspartnerLines
      )
    }
  }
`;

export const modifyBusinessPartnerLineCommission = gql`
  mutation modifyBusinessPartnerLineCommission(
    $input: ModifyBusinessPartnerLineCommissionInput!
  ) {
    salesforce {
      modifyBusinessPartnerLineCommission(
        modifyBusinessPartnerLineCommissionInput: $input
      )
    }
  }
`;

export const addBusinessPartnerPlans = gql`
  mutation addBusinessPartnerPlans($input: AddBusinessPartnerPlansInput!) {
    salesforce {
      addBusinessPartnerPlans(addBusinessPartnerPlansInput: $input)
    }
  }
`;

export const setPlansCommission = gql`
  mutation setPlansCommission($input: SetPlanCommissionInput!) {
    salesforce {
      setPlansCommission(setPlanCommissionInput: $input)
    }
  }
`;
